import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import GuestRoute from '@router/GuestRoute';
import {Routes} from 'react-router';
import TableOrderPage from "@pages/TableOrderPage";
import SuccessPage from "@pages/SuccessPage";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route element={<GuestRoute/>}>
          <Route exact path="/qr/:tableQr" element={<TableOrderPage/>}/>
          <Route exact path="/orders/details/:orderId" element={<SuccessPage/>}/>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
